
export class VisionValuesStat {
id: number | null;
nbLines: number | null;
stepLevel: number | null;
visionCode: string;
}

